export const SKIPPED_TO_HOME = 'venn-onboarding-skipped-to-home';
